import React from 'react'
import { RefreshCw } from 'lucide-react'
import { Tag, StatusLabel, Spinner } from '../ui'
import { formatRelative, roleLabel } from '../../lib/support'

// The reason a person can't sign in is written inline — it used to be a hover-only title.
export const AccessTab = ({ staff, loading, onRefresh }) => (
  <section className="card flex flex-col gap-2 overflow-x-auto p-4">
    <div className="flex items-center gap-2">
      <h4 className="flex-1 text-sm">Equipe e acesso</h4>
      <button type="button" className="btn btn-secondary" onClick={onRefresh} disabled={loading}>
        <RefreshCw className={`h-3.5 w-3.5 ${loading ? 'animate-spin' : ''}`} />
        Atualizar
      </button>
    </div>
    <p className="text-[13px] text-admin-600">
      As regras de acesso são as mesmas do portal do estúdio: estúdio ativo, usuário ativo e senha definida.
    </p>
    {loading && staff.length === 0 ? (
      <Spinner />
    ) : staff.length === 0 ? (
      <p className="py-4 text-[13px] text-admin-600">Nenhum usuário da equipe neste estúdio.</p>
    ) : (
      <table className="data-table min-w-[720px]">
        <thead>
          <tr>
            <th>Pessoa</th>
            <th>Função</th>
            <th>Consegue entrar</th>
            <th>Último acesso</th>
          </tr>
        </thead>
        <tbody>
          {staff.map((u) => (
            <tr key={u.id}>
              <td>
                <div className="flex flex-col leading-snug">
                  <span className="font-semibold">{u.name || '—'}</span>
                  <span className="mono text-xs text-admin-600">{u.email}</span>
                </div>
              </td>
              <td>
                <Tag tone="muted">{roleLabel(u.role)}</Tag>
              </td>
              <td>
                <div className="flex flex-col gap-0.5">
                  <StatusLabel tone={u.can_login ? 'ok' : 'crit'} className="font-semibold">
                    {u.can_login ? 'Sim' : 'Não'}
                  </StatusLabel>
                  <span className="text-xs text-admin-600">
                    {u.can_login
                      ? 'Estúdio ativo, usuário ativo, senha definida'
                      : u.cannot_login_reason || 'Não consegue entrar'}
                  </span>
                </div>
              </td>
              <td className="whitespace-nowrap">{u.last_login_at ? formatRelative(u.last_login_at) : 'Nunca'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    )}
  </section>
)
